import config from '../config'
import { authRequest } from '../request'

const { mainApi } = config

export type SystemDocItem = {
  title: string
  path: string
  description?: string
}

export type SystemDocGroup = {
  title: string
  docs: SystemDocItem[]
}

export type SystemDocIndex = {
  defaultDoc: string
  groups: SystemDocGroup[]
}

export const getSystemDocIndex = () =>
  authRequest.get<MISSING_TYPE, SystemDocIndex>(`${mainApi}/system-docs`)

export const getSystemDoc = (path: string) =>
  authRequest.get<MISSING_TYPE, string>(`${mainApi}/system-docs/content`, { params: { path } })
